/* eslint-disable react/prop-types */ // TODO: add props
import PT from 'prop-types';
import ShareLink from 'edrolo/components/common/ShareLink';
import { QuestionMetadata } from 'edrolo/domains/exams/components/QuestionMetadata';

import style from './QuestionHeader.scss';

export const QuestionHeader = ({
  classId,
  examId,
  question,
  instructionsText,
}) => {
  const serial = question.get('full_serial');
  const questionId = question.get('id')?.toString();
  const marks = +question.get('marks');
  const spicinessLevel = question.get('spiciness_level');
  const workingPathways = question.get('working_pathways')?.toArray();
  const skills = question.get('skills')?.toJS();

  return (
    <div className={style.container}>
      <div className={style.title}>
        <h1 className={style.header}>
          {`Q${serial}: `}
          {instructionsText}
        </h1>
        <div className={style.shareLinkContainer}>
          <ShareLink
            title="To share this question, copy and paste this link:"
            appLabel="exams"
            model="exam"
            objectId={examId}
            shareType="question-set-question"
            origin="question-set-question"
            utm_campaign="question-set-question"
            classId={classId}
            queryStringParams={{
              questionId,
            }}
          >
            <button className="share-link">
              <i className="icon-share-square-o" />
            </button>
          </ShareLink>
        </div>
      </div>

      <QuestionMetadata
        marks={marks}
        spicinessLevel={spicinessLevel}
        workingPathways={workingPathways}
        skills={skills}
      />
    </div>
  );
};

QuestionHeader.propTypes = {
  classId: PT.string.isRequired,
  examId: PT.string.isRequired,
  question: PT.object.isRequired,
  instructionsText: PT.string.isRequired,
};
